export const ATTR_PREFIX = "et-";
